import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsGiteeComponent } from './simple-icons-gitee.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsGiteeComponent ],
    exports:      [ SimpleIconsGiteeComponent ],
    bootstrap:    []
})
export class SimpleIconsGiteeModule {}
